import { Flex, Spin } from "@ir/ui";

const InternalConversationLoadMore = () => {
  return (
    <Flex align="center" justifyContent="center" className="pb-5 loader-more">
      <Spin spinning aria-label="Large Spin" size="small" />
    </Flex>
  );
};

export default InternalConversationLoadMore;
